;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	var Model = APP.module('Model');

	Model.Tipping = Backbone.Model.extend({
		url: function() {
			return this.methodUrl;
		},

		isNew: function(){
			return true;
		},

		save_tip: function(data) {
			return this.setApiUrl('tip/save').save({}, {data: data});
		},

		save_list: function(data) {
			return this.setApiUrl('tip/save_list').save({}, {data: data});
		},

		loadSnapshot: function() {
			return this.setApiUrl('tipping_stats/show_snapshot');
		},

		checkAverage: function() {

			_.each(this.toJSON(), function(value) {
				if (_.isNumber(value) && value % 1 != 0) {
					value = value.toFixed(1);
				}
			});

			return this;
		}

	});

}(window, APP, Backbone, Marionette, $, _));